export default "__VITE_ASSET__DmhXe2sb__"